// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwChipList from 'viewmodel/AwChipListViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import AwI18n from 'viewmodel/AwI18nViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwImageCell from 'viewmodel/AwImageCellViewModel';
import DesCompactImageCell from 'viewmodel/DesCompactImageCellViewModel';
import DesCatalogCustomCell from 'viewmodel/DesCatalogCustomCellViewModel';
    import { ExistWhen } from 'js/hocCollection';
const DivExistWhen = ExistWhen('div');
DivExistWhen.displayName = 'DivExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
registerDynImportEntry('js/DesCatalogImagesViewService', () => import('js/DesCatalogImagesViewService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "props": {
        "accsessionid": {
            "type": "STRING"
        },
        "catalogspaceid": {
            "type": "STRING"
        },
        "provider": {
            "type": "STRING"
        },
        "querystring": {
            "type": "STRING"
        },
        "display": {
            "type": "STRING"
        },
        "contentpath": {
            "type": "string"
        },
        "locale": {
            "type": "string"
        },
        "limit": {
            "type": "int"
        },
        "filterunit": {
            "type": "string"
        }
    },
    "lifecycleHooks": {
        "onUpdate": [
            {
                "action": "onUpdateBatchJob",
                "observers": [
                    "props.accsessionid",
                    "props.catalogspaceid",
                    "props.provider",
                    "props.querystring",
                    "props.display",
                    "props.locale",
                    "props.contentpath",
                    "props.filterunit"
                ]
            }
        ],
        "onUnmount": "onUnmountBatchAction"
    },
    "data": {
        "constants": {
            "REGULAR": "regular",
            "COMPACT": "compact",
            "CUSTOM": "custom"
        },
        "desTotalCount": 0,
        "facetFilter": [],
        "dynamicCrumb": [],
        "showResultsCount": false,
        "size": "{{props.limit}}",
        "selectionChip": {
            "type": "STRINGARRAY",
            "displayName": "Selection Chip",
            "isArray": true,
            "dbValue": []
        },
        "clearFilters": {
            "displayName": "{{clear...}}",
            "type": "STRING",
            "isRequired": "false"
        },
        "featureGroupId": "{{props.contentpath}}",
        "resetAttributes": false
    },
    "actions": {
        "loadData": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "appBaseUrl": "assets",
                        "additionalProperties": {
                            "allCatalogs": "true",
                            "cadenasQuery": "{{data.eventData.eventData[1] || props.querystring || ctx.queryString}}",
                            "digiKeyAuth": "",
                            "digiKeyQuery": "{{data.eventData.eventData[1] || props.querystring || ctx.queryString}}",
                            "facetFilters": "{{data.facetFilter}}",
                            "provider": "{{props.provider}}",
                            "desTotalCount": "{{data.desTotalCount}}"
                        },
                        "query": "query SearchObjects( $from: Int, $size: Int, $catalogspaceId: String, $featureGroupId: String, $locale: String, $filterUnit: String ) {searchObjects( from: $from, size: $size, catalogspaceId: $catalogspaceId, featureGroupId: $featureGroupId, locale: $locale, filterUnit: $filterUnit )}",
                        "variables": {
                            "from": "{{data.desTotalCount}}",
                            "size": "{{data.size}}",
                            "catalogspaceId": "{{props.catalogspaceid}}",
                            "featureGroupId": "{{data.data.featureGroupId}}",
                            "locale": "{{props.locale}}",
                            "filterUnit": "{{props.filterunit}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "searchObjects": "data.data.searchObjects.searchObjs",
                "desTotalCount": "data.data.searchObjects.desTotalCount",
                "totalCount": "data.data.searchObjects.totalCount",
                "facets": "data.data.searchObjects.facets[0].buckets",
                "facetFilterData": "data.data.searchObjects.facets",
                "searchedQuery": "data.data.searchObjects.searchedQuery"
            },
            "events": {
                "success": [
                    {
                        "name": "desSearchResultsSuccess"
                    },
                    {
                        "name": "des-catalog-search-result.success",
                        "eventData": {
                            "eventName": "des-catalog-search-result.success",
                            "eventData": "{{data.facetFilterData}}"
                        }
                    },
                    {
                        "name": "desSearchFacetResultsSuccess"
                    },
                    {
                        "name": "update-disable-filter-check-box-ctx-to-false"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "reveal": {
            "actionType": "dataProvider",
            "methods": [
                "performSearch",
                "selectionChipDataProvider"
            ]
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "setFilter": {
            "actionType": "JSFunction",
            "method": "setFilter",
            "inputData": {
                "vmo": "{{data}}",
                "selectedFacetFilter": "{{parameters.selectedFacetFilter}}"
            },
            "deps": "js/desSearchService"
        },
        "facetFilterLocalizationDes": {
            "actionType": "JSFunction",
            "method": "facetFilterLocalizationDes",
            "inputData": {
                "vmo": "{{data}}",
                "provider": "{{props.provider}}",
                "i18n": "{{i18n}}"
            },
            "deps": "js/desSearchService"
        },
        "createPartSelectionEvent": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "createPartSelectionEvent",
                        "eventData": {
                            "eventName": "createPartSelectionEvent",
                            "eventData": "{{parameters.eventData[0].cellHeader1 || parameters.eventData[0].cellHeader2 }}"
                        }
                    }
                ]
            }
        },
        "performBatchActionForFacetSelected": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "setFilter"
                },
                {
                    "action": "reveal"
                }
            ]
        },
        "performBatchAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "createPartSelectionEvent",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "showSearchResultsCount": {
            "actionType": "JSFunction",
            "method": "showSearchResultsCount",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/desSearchService"
        },
        "clearSeachBox": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "clearSeachBoxEvent"
                    }
                ]
            }
        },
        "showBreadCrumb": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "showBreadCrumbEvent",
                        "eventData": {
                            "eventData": "{{data.eventData.eventData}}"
                        }
                    }
                ]
            }
        },
        "addFilterChip": {
            "actionType": "JSFunction",
            "method": "addFilterChip",
            "inputData": {
                "chipArray": "{{data.facetFilter}}"
            },
            "outputData": {
                "filterChips": ""
            },
            "deps": "js/desSearchService"
        },
        "loadSelectionChips": {
            "actionType": "JSFunction",
            "method": "getAllSelectionChips",
            "inputData": {
                "props": "{{props}}"
            },
            "outputData": {
                "totalFound": "totalResults",
                "searchResults": "selectionChipModel"
            },
            "deps": "js/desSearchService"
        },
        "removeFilterAction": {
            "actionType": "JSFunction",
            "method": "removeFilter",
            "inputData": {
                "vmo": "{{data}}",
                "chipToRemove": "{{parameters.chip}}"
            },
            "outputData": {
                "filterChips": ""
            },
            "events": {
                "success": [
                    {
                        "name": "batch-remove-filter-action"
                    }
                ]
            },
            "deps": "js/desSearchService"
        },
        "resetAllCheckedvalues": {
            "actionType": "JSFunction",
            "method": "resetAllCheckedvalues",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "events": {
                "success": [
                    {
                        "name": "filterChipDataProvider.reset"
                    }
                ]
            },
            "deps": "js/desSearchService"
        },
        "batchAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "resetAllCheckedvalues"
                },
                {
                    "action": "updateDisableFilterCheckBoxCtxToTrue"
                },
                {
                    "action": "actionOnSearchIconClick",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "reveal",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "updateResetAttributeVariable": {
            "actionType": "JSFunction",
            "method": "updateResetAttributeVariable",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/desSearchService"
        },
        "batchRemoveFilterAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "updateDisableFilterCheckBoxCtxToTrue"
                },
                {
                    "action": "updateResetAttributeVariable"
                },
                {
                    "action": "reveal"
                }
            ]
        },
        "actionOnSearchIconClick": {
            "actionType": "JSFunction",
            "method": "setFromValueToZero",
            "inputData": {
                "data": "{{data}}",
                "desTotalCountVariable": "{{parameters.eventData}}"
            },
            "deps": "js/desSearchService"
        },
        "updateDisableFilterCheckBoxCtxToFalse": {
            "actionType": "JSFunction",
            "method": "updateCtx",
            "inputData": {
                "path": "disableSearchFilterCheckBox",
                "value": false
            },
            "deps": "js/appCtxService"
        },
        "updateDisableFilterCheckBoxCtxToTrue": {
            "actionType": "JSFunction",
            "method": "updateCtx",
            "inputData": {
                "path": "disableSearchFilterCheckBox",
                "value": true
            },
            "deps": "js/appCtxService"
        },
        "onUpdateBatchJob": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "checkFilterFromProps"
                },
                {
                    "action": "reveal"
                }
            ]
        },
        "checkFilterFromProps": {
            "actionType": "JSFunction",
            "method": "checkFilterFromProps",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "deps": "js/desSearchService"
        },
        "initIntersectionObserver": {
            "actionType": "JSFunction",
            "method": "initIntersectionObserver",
            "inputData": {
                "Imageobjects": "{{data.searchObjects}}",
                "provider": "{{props.provider}}",
                "acc": "des-catalog-search-results",
                "vmo": "{{data}}",
                "display": "{{props.display}}"
            },
            "deps": "js/DesCatalogImagesViewService"
        },
        "disconnectIntersectionObserver": {
            "actionType": "JSFunction",
            "method": "disconnectIntersectionObserver",
            "deps": "js/DesCatalogImagesViewService"
        },
        "desSearchResultsSuccessBatchJob": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "showSearchResultsCount"
                },
                {
                    "action": "initIntersectionObserver"
                }
            ]
        },
        "onUnmountBatchAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "disconnectIntersectionObserver"
                },
                {
                    "action": "clearSeachBox"
                },
                {
                    "action": "resetAllCheckedvalues"
                }
            ]
        }
    },
    "dataProviders": {
        "performSearch": {
            "action": "loadData",
            "response": "{{data.searchObjects}}",
            "totalFound": "{{data.totalCount}}"
        },
        "filterChipDataProvider": {
            "type": "Static",
            "response": "{{data.filterChips}}",
            "selectionModelMode": "none"
        },
        "selectionChipDataProvider": {
            "action": "loadSelectionChips",
            "response": "{{data.searchResults}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "multiple"
        }
    },
    "onEvent": [
        {
            "eventId": "searchInitiatedSuccess",
            "action": "batchAction",
            "inputArgs": {
                "eventName": "searchInitiatedSuccess",
                "eventData": "{{eventData.eventData}}"
            },
            "cacheEventData": true
        },
        {
            "eventId": "performSearch.selectionChangeEvent",
            "cacheEventData": true,
            "action": "performBatchAction",
            "inputArgs": {
                "eventName": "desPartSelectionChange",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "desSearchResultsSuccess",
            "action": "desSearchResultsSuccessBatchJob"
        },
        {
            "eventId": "desSearchFacetResultsSuccess",
            "action": "facetFilterLocalizationDes"
        },
        {
            "eventId": "des-search-filter.selectionChange",
            "action": "performBatchActionForFacetSelected",
            "inputArgs": {
                "eventName": "des-search-filter.selectionChange",
                "selectedFacetFilter": "{{eventData}}"
            }
        },
        {
            "eventId": "crumbClickedToNavigateToSearchResults",
            "action": "reveal"
        },
        {
            "eventId": "filterChipDataProvider.reset",
            "action": "reveal"
        },
        {
            "eventId": "update-disable-filter-check-box-ctx-to-true",
            "action": "updateDisableFilterCheckBoxCtxToTrue"
        },
        {
            "eventId": "update-disable-filter-check-box-ctx-to-false",
            "action": "updateDisableFilterCheckBoxCtxToFalse"
        },
        {
            "eventId": "batch-remove-filter-action",
            "action": "batchRemoveFilterAction"
        },
        {
            "eventId": "searchBoxClearEvent",
            "action": "resetAllCheckedvalues"
        }
    ],
    "conditions": {
        "displayRegularView": {
            "expression": "props.display === data.constants.REGULAR"
        },
        "displayCompactView": {
            "expression": "props.display === data.constants.COMPACT"
        },
        "displayChipList": {
            "expression": "data.searchResults.length !== 0"
        },
        "displayCustomView": {
            "expression": "props.display === data.constants.CUSTOM"
        }
    },
    "i18n": {
        "clearButton": [
            "searchMessages"
        ],
        "resultFoundFor": [
            "searchMessages"
        ],
        "ByCatalogs": [
            "searchMessages"
        ],
        "BySuppliers": [
            "searchMessages"
        ],
        "ByManufacturer": [
            "searchMessages"
        ],
        "ByProperties": [
            "searchMessages"
        ],
        "BySegments": [
            "searchMessages"
        ],
        "ByStandards": [
            "searchMessages"
        ]
    },
    "_viewModelId": "DesCatalogSearchResults",
    "_uniqueViewModelId": "DesCatalogSearchResults",
    "ctx": {
        "queryString": {
            "type": "object"
        }
    }
};

    /*
    <div exist-when="conditions.displayRegularView"
    class="des-search-cellListItem des-display-regular" style="height: 100%;">
    <!-- Work Around: Need to use aw-label -->
    <div exist-when="data.showResultsCount" class="sw-column" style="height:100%; width:100%">
        <div class="des-search-result-info-content">
            <div class="totalFoundStringStyle">
                <h4 class="countStyle">{{data.totalCount}} {{i18n.resultFoundFor}} "{{data.searchedQuery}}"</h4>
            </div>
            <div class="sw-flex-row aw-layout-wrap flex-auto" style="height: 100%; flex: 1 1 auto; margin: 4px;"
                exist-when="conditions.displayChipList">
                <aw-panel-body class="h-12">
                    <aw-chip-list dataprovider="data.dataProviders.selectionChipDataProvider"
                        button-type="accent-mid-contrast" ui-icon-action="removeFilterAction">
                    </aw-chip-list>
                </aw-panel-body>
            </div>
            <div class="sw-flex-row aw-layout-wrap flex-auto clearButtonStyle" exist-when="conditions.displayChipList">
                <aw-button button-type='chromeless' action="resetAllCheckedvalues" size='auto'>
                    <aw-i18n>{{i18n.clearButton}}</aw-i18n>
                </aw-button>
            </div>
        </div>
        <div class="des-search-results-content">
            <aw-list has-floating-cell-commands="false" dataprovider="data.dataProviders.performSearch">
                <aw-image-cell vmo="item"></aw-image-cell>
            </aw-list>
        </div>
    </div>
</div>
<div exist-when="conditions.displayCompactView" class="des-search-results-content des-search-cellListItem"
    style="height: 100%;">
    <!-- Work Around: Need to use aw-label -->
    <div exist-when="data.showResultsCount" class="sw-column" style="height:100%; width:100%">
        <div class="des-search-result-info-content">
            <div class="totalFoundStringStyle">
                <h4 class="countStyle">{{data.totalCount}} {{i18n.resultFoundFor}} "{{data.searchedQuery}}"</h4>
            </div>
            <div class="sw-flex-row aw-layout-wrap flex-auto" style="height: 100%; flex: 1 1 auto;"
                exist-when="conditions.displayChipList">
                <aw-panel-body class="h-12">
                    <aw-chip-list dataprovider="data.dataProviders.selectionChipDataProvider"
                        button-type="accent-mid-contrast" ui-icon-action="removeFilterAction">
                    </aw-chip-list>
                </aw-panel-body>
            </div>
            <div class="sw-flex-row aw-layout-wrap flex-auto clearButtonStyle" exist-when="conditions.displayChipList">
                <aw-button button-type='chromeless' action="resetAllCheckedvalues" size='auto'>
                    <aw-i18n>{{i18n.clearButton}}</aw-i18n>
                </aw-button>
            </div>
        </div>
        <div class="des-search-results-content">
            <aw-list has-floating-cell-commands="false" dataprovider="data.dataProviders.performSearch">
                <des-compact-image-cell vmo="item"></des-compact-image-cell>
            </aw-list>
        </div>
    </div>
</div>

<div exist-when="conditions.displayCustomView" class="des-search-results-content des-search-cellListItem"
    style="height: 100%;">
    <!-- Work Around: Need to use aw-label -->
    <div exist-when="data.showResultsCount" class="sw-column" style="height:100%; width:100%">
        <div class="des-search-result-info-content-custom-style">
            <div class="totalFoundStringStyle">
                <h4 class="countStyleCustom">{{data.totalCount}} {{i18n.resultFoundFor}} "{{data.searchedQuery}}"</h4>
            </div>
            <div class="sw-flex-row aw-layout-wrap flex-auto" style="height: 100%; flex: 1 1 auto;"
                exist-when="conditions.displayChipList">
                <aw-panel-body class="h-12">
                    <aw-chip-list dataprovider="data.dataProviders.selectionChipDataProvider"
                        button-type="accent-mid-contrast" ui-icon-action="removeFilterAction">
                    </aw-chip-list>
                </aw-panel-body>
            </div>
            <div class="sw-flex-row aw-layout-wrap flex-auto clearButtonStyle" exist-when="conditions.displayChipList">
                <aw-button button-type='chromeless' action="resetAllCheckedvalues" size='auto'>
                    <aw-i18n>{{i18n.clearButton}}</aw-i18n>
                </aw-button>
            </div>
        </div>
        <div class="des-search-results-content">
            <aw-list has-floating-cell-commands="false" dataprovider="data.dataProviders.performSearch">
                <des-catalog-custom-cell vmo="item"></des-catalog-custom-cell>
            </aw-list>
        </div>
    </div>
</div>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
            <Fragment>
    <DivExistWhen className="des-search-cellListItem des-display-regular" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayRegularView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <DivExistWhen className="sw-column" style={{height: '100%', width: '100%'}} existWhen={AwParseService.instance( "data.showResultsCount" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            <div className="des-search-result-info-content">
                <div className="totalFoundStringStyle">
                    <h4 className="countStyle">
                        {AwParseService.instance( "data.totalCount" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} {AwParseService.instance( "i18n.resultFoundFor" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} &quot;{AwParseService.instance( "data.searchedQuery" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}&quot;
                    </h4>
                </div>
                <DivExistWhen className="sw-flex-row aw-layout-wrap flex-auto" style={{height: '100%', flex: '1 1 auto', margin: '4px'}} existWhen={AwParseService.instance( "conditions.displayChipList" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <AwPanelBody className="h-12">
                        <AwChipList  dataprovider={dataProviders.selectionChipDataProvider}  chipCondition={AwParseService.instance( "{conditions}" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} buttonType="accent-mid-contrast" uiIconAction={actions.removeFilterAction}>
                        </AwChipList>
                    </AwPanelBody>
                </DivExistWhen>
                <DivExistWhen className="sw-flex-row aw-layout-wrap flex-auto clearButtonStyle" existWhen={AwParseService.instance( "conditions.displayChipList" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <AwButton buttonType="chromeless" action={actions.resetAllCheckedvalues} size="auto">
                        <AwI18n>
                            {AwParseService.instance( "i18n.clearButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                        </AwI18n>
                    </AwButton>
                </DivExistWhen>
            </div>
            <div className="des-search-results-content">
                <AwList dataprovider={dataProviders.performSearch} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <AwImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </AwImageCell></> } }
                </AwList>
            </div>
        </DivExistWhen>
    </DivExistWhen>
    <DivExistWhen className="des-search-results-content des-search-cellListItem" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayCompactView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <DivExistWhen className="sw-column" style={{height: '100%', width: '100%'}} existWhen={AwParseService.instance( "data.showResultsCount" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            <div className="des-search-result-info-content">
                <div className="totalFoundStringStyle">
                    <h4 className="countStyle">
                        {AwParseService.instance( "data.totalCount" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} {AwParseService.instance( "i18n.resultFoundFor" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} &quot;{AwParseService.instance( "data.searchedQuery" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}&quot;
                    </h4>
                </div>
                <DivExistWhen className="sw-flex-row aw-layout-wrap flex-auto" style={{height: '100%', flex: '1 1 auto'}} existWhen={AwParseService.instance( "conditions.displayChipList" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <AwPanelBody className="h-12">
                        <AwChipList  dataprovider={dataProviders.selectionChipDataProvider}  chipCondition={AwParseService.instance( "{conditions}" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} buttonType="accent-mid-contrast" uiIconAction={actions.removeFilterAction}>
                        </AwChipList>
                    </AwPanelBody>
                </DivExistWhen>
                <DivExistWhen className="sw-flex-row aw-layout-wrap flex-auto clearButtonStyle" existWhen={AwParseService.instance( "conditions.displayChipList" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <AwButton buttonType="chromeless" action={actions.resetAllCheckedvalues} size="auto">
                        <AwI18n>
                            {AwParseService.instance( "i18n.clearButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                        </AwI18n>
                    </AwButton>
                </DivExistWhen>
            </div>
            <div className="des-search-results-content">
                <AwList dataprovider={dataProviders.performSearch} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <DesCompactImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </DesCompactImageCell></> } }
                </AwList>
            </div>
        </DivExistWhen>
    </DivExistWhen>
    <DivExistWhen className="des-search-results-content des-search-cellListItem" style={{height: '100%'}} existWhen={AwParseService.instance( "conditions.displayCustomView" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <DivExistWhen className="sw-column" style={{height: '100%', width: '100%'}} existWhen={AwParseService.instance( "data.showResultsCount" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            <div className="des-search-result-info-content-custom-style">
                <div className="totalFoundStringStyle">
                    <h4 className="countStyleCustom">
                        {AwParseService.instance( "data.totalCount" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} {AwParseService.instance( "i18n.resultFoundFor" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} &quot;{AwParseService.instance( "data.searchedQuery" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}&quot;
                    </h4>
                </div>
                <DivExistWhen className="sw-flex-row aw-layout-wrap flex-auto" style={{height: '100%', flex: '1 1 auto'}} existWhen={AwParseService.instance( "conditions.displayChipList" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <AwPanelBody className="h-12">
                        <AwChipList  dataprovider={dataProviders.selectionChipDataProvider}  chipCondition={AwParseService.instance( "{conditions}" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} buttonType="accent-mid-contrast" uiIconAction={actions.removeFilterAction}>
                        </AwChipList>
                    </AwPanelBody>
                </DivExistWhen>
                <DivExistWhen className="sw-flex-row aw-layout-wrap flex-auto clearButtonStyle" existWhen={AwParseService.instance( "conditions.displayChipList" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    <AwButton buttonType="chromeless" action={actions.resetAllCheckedvalues} size="auto">
                        <AwI18n>
                            {AwParseService.instance( "i18n.clearButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                        </AwI18n>
                    </AwButton>
                </DivExistWhen>
            </div>
            <div className="des-search-results-content">
                <AwList dataprovider={dataProviders.performSearch} showDropArea={null} hasFloatingCellCommands={false} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <DesCatalogCustomCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </DesCatalogCustomCell></> } }
                </AwList>
            </div>
        </DivExistWhen>
    </DivExistWhen>
</Fragment>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;